module.exports = "/cyber/_next/static/images/messageDark-4e40e9a21ca088ffb3f017fb97e557e5.png";